// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-dialog-callout-content {
  margin: 16px;
  border-radius: 6px;
  overflow: hidden;
}
@media (forced-colors: active) {
  .bolt-dialog-callout-content {
    border: solid 1px;
  }
}
.bolt-dialog-callout-content.bolt-callout-shadow {
  box-shadow: 0px 25.6px 57.6px rgba(0, 0, 0, .22), 0px 4.8px 14.4px rgba(0, 0, 0, .18);
  box-shadow: 0px 25.6px 57.6px var(--panel-shadow-color,rgba(0, 0, 0, .22)), 0px 4.8px 14.4px var(--panel-shadow-secondary-color,rgba(0, 0, 0, .18));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-dialog-callout-content.bolt-callout-shadow {
  box-shadow: none;
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-dialog-callout-content.bolt-callout-shadow {
  box-shadow: none;
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-dialog-callout-content.bolt-dialog-mobile {
  margin-left: 32px;
  margin-right: 32px;
  min-width: 0px;
}

.bolt-lower-right-corner-dialog-content {
  width: 420px;
}
@media only screen and (max-width: 600px) {
  .bolt-lower-right-corner-dialog-content {
    width: 240px;
  }
}

.bolt-dialog .bolt-panel-footer {
  padding: 16px 20px;
}

.bolt-dialog-content {
  padding-bottom: 4px;
}

.bolt-dialog-content-bottom-padding {
  padding-bottom: 32px;
}

.bolt-dialog-content {
  overflow: auto;
  position: relative;
}

.bolt-dialog-callout.no-events {
  pointer-events: none;
}

.bolt-dialog {
  pointer-events: auto;
}

.bolt-dialog-resize-icon {
  margin-left: auto;
  padding-right: 4px;
  padding-bottom: 4px;
  cursor: se-resize;
}

.bolt-dialog .bolt-dialog-resizable-footer {
  padding-bottom: 0;
  min-height: 48px;
}

.bolt-dialog-overlay {
  background-color: rgba(255, 255, 255, 0.86);
  background-color: var(--callout-filtered-background-color,rgba(255, 255, 255, 0.86));
}
@media (forced-colors: active) {
  .bolt-dialog-overlay {
    background: transparent;
  }
}

/*# sourceMappingURL=Dialog.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Dialog/Dialog.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Dialog/Dialog.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,YC+TS;ED9TT,kBAAA;EACA,gBAAA;AEAJ;AC2CI;EH9CJ;IAMQ,iBAAA;EECN;AACF;AFCI;EACI,qFAAA;EECN,mJAAmJ;AD8X7I;AC5XR;EFCY,gBAAA;EECV,sCAAsC;ED6XhC,gEAAA;AC3XR;AACA;EACE,gBAAgB;EFDd,sCAAA;EACI,gECwTK;ACrTb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EFApB,cAAA;AEEA;;AFAI;EAFJ,YAAA;AEMA;AACA;EACE;IACE,YAAY;EFFhB;AEIA;;AAEA;EFFA,kBAAA;AEIA;;AAEA;EFFA,mBAAA;AEIA;;AAEA;EFFA,oBAAA;AEIA;;AAEA;EACE,cAAc;EFFhB,kBAAA;AEIA;;AAEA;EFFA,oBAAA;AEIA;;AAEA;EFFA,oBAAA;AEIA;;AAEA;EFFI,iBAAA;EEIF,kBAAkB;EAClB,mBAAmB;EFFrB,iBAAA;AEIA;;AAEA;EACE,iBAAiB;EFFnB,gBAAA;AEIA;;AC3BI;EHuBJ,2CAAA;EEQE,oFFJM;AEKR;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
